import { render, staticRenderFns } from "./FlowMyBusinessModal.vue?vue&type=template&id=23e2db44"
import script from "./FlowMyBusinessModal.vue?vue&type=script&lang=js"
export * from "./FlowMyBusinessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports